export default __webpack_public_path__ + "static/media/g10-background.e8950463.jpg";